module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("With Material Design Icons")]), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Country",
      "icon": "earth"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")])])], 1), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Client",
      "icon": "account"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")])])], 1), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("With FontAwesome")]), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Country",
      "icon": "globe",
      "icon-pack": "fas"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")])])], 1), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Client",
      "icon": "user",
      "icon-pack": "fas"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa36e92"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/select/examples/ExIcons.vue
// module id = 1170
// module chunks = 29 197